import React from 'react';

// Load package.json using require
const packageJson = require('../../../package.json'); // Adjust the path as needed

export default function Footer() {
    const {
        name, version
    } = packageJson; // Destructure the properties
    return (
        <footer className='bg-background text-[var(--primary-color)] text-[16px] py-2 p-6 flex border-t border-border'>
            <div className='w-full font-[400] flex justify-between items-center'>
                <div className="flex gap-1 text-muted-foreground text-xs">
                    <p> Version: TS-{version}</p>
                    <p> &copy; {new Date().getFullYear()} {name}. All rights reserved.</p>
                </div>
                <h2 className='text-sm'>Executing with Agility, Velocity, and Precision</h2>
            </div>
        </footer>
    );

}
